import { HttpContextToken, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

/** Public LIFF／Bridge 不使用 legacy Account Bearer；由呼叫端明確標記，避免誤套用。 */
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

/**
 * 處理 Ajax Request 的攔截器
 */
export class AuthHttpInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(SKIP_AUTH)) {
      return next.handle(req);
    }

    const token = localStorage.getItem('token');
    if (!token) {
      return next.handle(req);
    }

    // 攔截要發出去的 HTTP Request
    const newRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    return next.handle(newRequest);
  }
}
